import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock } from "@fortawesome/free-solid-svg-icons";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {functions} from "../constants/common-functions";
import {STRINGIFY} from "../constants/general-constants";

export default function ChangePasswordCard({ onClose }) {

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  
  const [errors, setErrors] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  
  function validatePasswordRules(currentPwd, newPwd, confirmPwd) {

    var newErrors = [];
    var newFieldErrors = {
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    };

    if (!currentPwd || currentPwd.trim().length === 0) {
      newFieldErrors.currentPassword = "Current password is required.";
      newErrors.push(newFieldErrors.currentPassword);
    }

    if (!newPwd || newPwd.trim().length === 0) {
      newFieldErrors.newPassword = "New password is required.";
      newErrors.push(newFieldErrors.newPassword);
    }

    if (!confirmPwd || confirmPwd.trim().length === 0) {
      newFieldErrors.confirmPassword = "Please confirm your new password.";
      newErrors.push(newFieldErrors.confirmPassword);
    }

    if (newPwd && currentPwd && newPwd === currentPwd) {
      newFieldErrors.newPassword = "New password must be different to current password.";
      newErrors.push(newFieldErrors.newPassword);
    }

    if (newPwd && confirmPwd && newPwd !== confirmPwd) {
      newFieldErrors.confirmPassword = "Passwords do not match.";
      newErrors.push(newFieldErrors.confirmPassword);
    }

    if (newPwd) {

      if (newPwd.length < 12) {
        newErrors.push("Must be at least 12 characters long.");
      }

      if (!/[a-z]/.test(newPwd)) {
        newErrors.push("Must contain at least 1 lowercase letter.");
      }

      if (!/[A-Z]/.test(newPwd)) {
        newErrors.push("Must contain at least 1 uppercase letter.");
      }

      if (!/[0-9]/.test(newPwd)) {
        newErrors.push("Must contain at least 1 number.");
      }

      if (!/[^A-Za-z0-9]/.test(newPwd)) {
        newErrors.push("Must contain at least 1 special character.");
      }
    }

    setErrors(newErrors);
    setFieldErrors(newFieldErrors);

    return newErrors.length === 0;
  }

  function submitChange() {

    var ok = validatePasswordRules(currentPassword, newPassword, confirmPassword);

    if (!ok) {
      return;
    }

	functions.submitAjax("/resolutionsoftwareplatform/administration/user/change-password", 
					{newPassword:newPassword}, saveEnd,  STRINGIFY, handleSubmitError);
    onClose();
  };
  
  const handleSubmitError = (e) => {
  		console.log(e);
  	};
  	
  	const saveEnd = () => {
  		
  	};

  return (
    <div
      style={{
        position: "relative",
        width: "360px",
        padding: "50px 30px 30px",
        background: "#fff",
        borderRadius: "10px",
        boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
        textAlign: "center"
      }}
    >

      {/* DIAMOND ICON */}
      <div
        style={{
          position: "absolute",
          top: "-35px",
          left: "50%",
          transform: "translateX(-50%) rotate(45deg)",
          width: "70px",
          height: "70px",
          background: "linear-gradient(180deg, #4285F4 0%, #1E58B6 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 6px 14px rgba(0,0,0,0.3)"
        }}
      >
        <FontAwesomeIcon
          icon={faUser}
          style={{
            color: "#fff",
            fontSize: "28px",
            transform: "rotate(-45deg)"
          }}
        />
      </div>

      <h3 style={{ marginBottom: "25px" }}>Change Password</h3>

      <TextField
        fullWidth
        type="password"
        placeholder="Current Password"
        value={currentPassword}
        onChange={e => setCurrentPassword(e.target.value)}
        style={{ marginBottom: "16px" }}
      />

      <TextField
        fullWidth
        type="password"
        placeholder="New Password"
        value={newPassword}
        onChange={e => setNewPassword(e.target.value)}
        style={{ marginBottom: "16px" }}
      />

      <TextField
        fullWidth
        type="password"
        placeholder="Confirm New Password"
        value={confirmPassword}
        onChange={e => setConfirmPassword(e.target.value)}
        style={{ marginBottom: "30px" }}
      />
	  
	  <div
	    style={{
	      textAlign: "left",
	      fontSize: "13px",
	      color: "#555",
	      background: "#f6f8fb",
	      border: "1px solid #e1e6ef",
	      borderRadius: "8px",
	      padding: "10px 12px",
	      marginBottom: "16px"
	    }}
	  >
	    <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
	      Password must:
	    </div>
	    <div>• Be at least 12 characters long</div>
	    <div>• Contain at least 1 uppercase letter</div>
	    <div>• Contain at least 1 lowercase letter</div>
	    <div>• Contain at least 1 number</div>
	    <div>• Contain at least 1 special character</div>
	  </div>

      <Button
        fullWidth
        variant="contained"
        style={{
          background: "#000",
          color: "#fff",
          height: "44px"
        }}
        onClick={submitChange}
      >
        Update Password
      </Button>

      <div
        onClick={onClose}
        style={{
          marginTop: "15px",
          fontSize: "13px",
          color: "#777",
          cursor: "pointer"
        }}
      >
        Cancel
      </div>
	  {errors && errors.length > 0 && (
	    <div
	      style={{
	        textAlign: "left",
	        background: "#fff5f5",
	        border: "1px solid #ffd1d1",
	        color: "#b71c1c",
	        padding: "10px 12px",
	        borderRadius: "8px",
	        marginBottom: "16px",
	        fontSize: "13px"
	      }}
	    >
	      {errors.map(function (msg, idx) {
	        return <div key={idx} style={{ marginBottom: "4px" }}>• {msg}</div>;
	      })}
	    </div>
	  )}

    </div>
  );
}
